// extracted by mini-css-extract-plugin
export default {"modal":"LogIn_modal__j--cq","title":"LogIn_title__IIojo"};